module.exports = __webpack_public_path__ + "img/rs_blackgreyT-logo.f6a7742.png";